// Local variables reducer
import { SET_PROFIT_LOSS_DATE_RANGE_AND_ITEM } from "./actionType";
const initialState = {
  profitLossDateRangeAndItem: [],
};
const LocalVariables = (state = initialState, action) => {
  switch (action.type) {
    case SET_PROFIT_LOSS_DATE_RANGE_AND_ITEM:
      return {
        ...state,
        profitLossDateRangeAndItem: action.payload,
      };
    default:
      return state;
  }
};
export default LocalVariables;
